// extracted by mini-css-extract-plugin
export default {"LegendStepIcon":"LegendStepIcon--rFd__"};